// Design tokens — single source of truth for colours, spacing, typography.
// Mirrors the `.ba-*` CSS variables defined in
// src/components/pages/landingPage.css. Kept as plain JS (no MUI import)
// so raw CSS, styled-components, and the MUI theme can all consume the
// same values.
//
// Dark-mode palette is included so a future ThemeProvider toggle is a
// mechanical change, but only the light palette is wired in this refresh.

export const tokens = {
    color: {
        // Brand
        amber:        '#F7B31D',
        amberDark:    '#D89100',
        amberDeep:    '#8B5E00',
        amberTint:    '#FFF3CC',
        amberWash:    '#FFFBF1',

        // Ink / text
        ink:          '#0F172A',
        inkStrong:    '#020617',
        inkMuted:     '#475569',
        inkSoft:      '#64748B',

        // Surfaces (light)
        bg:           '#FFFFFF',
        bgSoft:       '#FAFBFC',
        bgCream:      '#FFFBF1',

        // Lines / dividers
        line:         '#E7E5E4',
        lineWarm:     '#F3E1B5',

        // Surfaces (dark — reserved for future dark-mode toggle)
        dark1:        '#0B1220',
        dark2:        '#0F172A',
        dark3:        '#1E293B',
        onDark:       '#F8FAFC',
        onDarkSoft:   '#CBD5E1',
        onDarkMute:   '#94A3B8',

        // Status
        success:      '#16A34A',
        successBg:    '#DCFCE7',
        warning:      '#F59E0B',
        warningBg:    '#FEF3C7',
        error:        '#DC2626',
        errorBg:      '#FEF2F2',
        info:         '#0284C7',
        infoBg:       '#E0F2FE',
    },
    radius: {
        sm: 10,
        md: 16,
        lg: 20,
        pill: 999,
    },
    shadow: {
        sm:    '0 1px 2px rgba(15,23,42,0.06)',
        md:    '0 10px 30px rgba(15,23,42,0.10)',
        lg:    '0 20px 60px rgba(15,23,42,0.18)',
        amber: '0 10px 30px rgba(247,179,29,0.35)',
    },
    spacing: 8,
    fontFamily: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    ease: 'cubic-bezier(.22, 1, .36, 1)',
};

export default tokens;
